import {observable, computed, action, autorun, reaction, runInAction, toJS} from 'mobx';

import * as constants from '../model/const';

function range(start, end) {
  let result = [];
  for(let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

export class VBookingWizard {
  constructor(flasher, aggServices, aggAccessories) {
    this.flasher = flasher;
    this.aggServices = aggServices;
    this.aggAccessories = aggAccessories;
  }

  @observable visitedSteps = [];

  @action.bound resetVisitedSteps() {
    this.visitedSteps = [];
  }

  @action.bound setVisitedStep(step) {
    if(!this.visitedSteps.find(o => o === step)) {
      this.visitedSteps = range(1, parseInt(step) + 1);
    }
  }

  wasStepVisited(step) {
    return this.visitedSteps.find(o => o === parseInt(step)) !== undefined;
  }

  @computed get anyServicesToBook() {
    return (this.aggServices.joinedListing
      .filter(o => o.available.typeId === constants.SERVICE_TYPE.WAHLBAR && o.available.canBeSelected)
      .length > 0);
  }

  @computed get anyAccessoriesToBook() {
    return (this.aggAccessories.joinedListing.filter(o => o.hasBestOffers).length > 0);
  }

  @computed get nextOfferDetailsAction() {
    if(this.anyServicesToBook) {
      return "Services";
    } else {
      return this.nextServicesAction;
    }
  }

  @computed get nextServicesAction() {
    if(this.anyAccessoriesToBook) {
      return "Accessories";
    } else {
      return "PersonalData";
    }
  }

  @computed get prevAccessoriesAction() {
    if(this.anyServicesToBook) {
      return "Services";
    } else {
      return "OfferDetails";
    }
  }

  @computed get prevPersonalDataAction() { 
    if(this.anyAccessoriesToBook) {
      return "Accessories";
    } else {
      return this.prevAccessoriesAction;
    }
  }

  async start() {
  }

  stop() {
  }
}  


// WEBPACK FOOTER //
// ./src/view/VBookingWizard.js